import React from 'react';
import { Skeleton as AntSkeleton, Card, Space } from 'antd';

/**
 * 骨架屏组件（复用 antd Skeleton）
 * 说明：antd 5 无 Skeleton.Title / Skeleton.Paragraph 子组件，须用 title / paragraph 属性。
 * 用于权限检查与路由懒加载 Suspense 占位，避免内容闪现。
 */
const Skeleton = ({
  type = 'default', // default | card | form | table | list
  rows = 3,
  avatar = false,
  title = true,
  paragraph = true,
  ...props
}) => {
  const paragraphProp = paragraph ? { rows } : false;

  const renderDefaultSkeleton = () => (
    <div style={{ padding: '20px' }}>
      <AntSkeleton active avatar={avatar} title={title} paragraph={paragraphProp} />
    </div>
  );

  const renderCardSkeleton = () => (
    <Card style={{ margin: '16px' }}>
      <AntSkeleton active avatar={avatar} title={title} paragraph={paragraphProp} />
    </Card>
  );

  const renderFormSkeleton = () => (
    <div style={{ padding: '20px' }}>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {title ? <AntSkeleton active title paragraph={false} /> : null}
        <AntSkeleton.Input active size="large" block />
        <AntSkeleton.Input active size="large" block />
        <AntSkeleton.Input active size="large" block />
        <AntSkeleton.Input active size="large" block />
      </Space>
    </div>
  );

  const renderTableSkeleton = () => (
    <div style={{ padding: '20px' }}>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {title ? <AntSkeleton active title paragraph={false} /> : null}
        <AntSkeleton.Input active size="large" style={{ height: '40px' }} block />
        <AntSkeleton.Input active size="large" style={{ height: '40px' }} block />
        <AntSkeleton.Input active size="large" style={{ height: '40px' }} block />
        <AntSkeleton.Input active size="large" style={{ height: '40px' }} block />
      </Space>
    </div>
  );

  const renderListSkeleton = () => (
    <div style={{ padding: '20px' }}>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {title ? <AntSkeleton active title paragraph={false} /> : null}
        {Array.from({ length: rows }).map((_, index) => (
          <AntSkeleton
            key={index}
            active
            avatar={avatar}
            title={false}
            paragraph={{ rows: 1 }}
          />
        ))}
      </Space>
    </div>
  );

  const renderSkeleton = () => {
    switch (type) {
      case 'card':
        return renderCardSkeleton();
      case 'form':
        return renderFormSkeleton();
      case 'table':
        return renderTableSkeleton();
      case 'list':
        return renderListSkeleton();
      default:
        return renderDefaultSkeleton();
    }
  };

  return (
    <div {...props}>
      {renderSkeleton()}
    </div>
  );
};

export default Skeleton;
